import useMediaQuery from '@material-ui/core/useMediaQuery';

export function useMediaQueryDown(breakPoint = 'sm') {
  return useMediaQuery((theme) => theme.breakpoints.down(breakPoint));
}

export function useMediaQueryUp(breakPoint = 'sm') {
  return useMediaQuery((theme) => theme.breakpoints.up(breakPoint));
}
